import { AsyncPost } from './ajax';

let articlesElement = document.getElementById('load-articles');

if (articlesElement) {
  let resultCount = 8;

  getArticles(resultCount, 'news-articles__content');

  articlesElement.addEventListener('click', () => {
    resultCount += 8;
    getArticles(resultCount, 'news-articles__content');
  });
}

// Returns json of articles for given result
function getArticles(number, displayElementId) {
  let data = {
    action: 'AsyncGetPosts',
    count: number,
  };

  AsyncPost(data).then((response) => {
    document.getElementById(displayElementId).innerHTML = '';

    if (number >= response.found) {
      document.getElementById('load-articles').style.display = 'none';
    }

    let posts = response.results;
    for (let key in posts) {
      let card = makeArticleCard(posts[key]);
      document.getElementById('news-articles__content').appendChild(card);
    }
  });
}

// Returns article card
function makeArticleCard(post) {
  //Articles Card
  let card = document.createElement('a');
  card.className = 'articles-card';
  card.id = 'post-' + post.id;
  card.href = post.link;

  // Image container
  let imageContainer = document.createElement('div');
  imageContainer.className = 'articles-card__image';
  imageContainer.innerHTML = post.img;

  // Info container
  let infoContainer = document.createElement('div');
  infoContainer.className = 'articles-card__info';

  // Category information
  let infoCat = document.createElement('span');
  infoCat.className = 'articles-card__info-cat';
  infoCat.innerHTML = post.category;

  // Card title
  let infoTitle = document.createElement('h3');
  infoTitle.className = 'articles-card__info-title';
  infoTitle.innerHTML = post.title;

  // Putting the card elements together
  card.appendChild(imageContainer);
  infoContainer.appendChild(infoCat);
  infoContainer.appendChild(infoTitle);
  card.appendChild(infoContainer);

  return card;
}
